import React from "react";
import "./Projects.css";

import chachiCover from "../../images/chachiCover.png";
import imagineAiCover from "../../images/imagineAiCover.png";
import jagritiCover from "../../images/jagritiCover.png";
import robochartCover from "../../images/robochat.png";
import partypals from "../../images/partypals1.png";
import wwcNgo from '../../images/wwcCover.png';
import sageThreds from '../../images/sageThreads.png';

import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel,
} from "react-accessible-accordion";

const data = [
  {
    heading: "Warriors Without Cause",
    description: "Official website for Warriors Without Cause NGO — showcasing drives, events, and community initiatives in a clean, engaging platform.",
    techStack: ['ReactJS', 'Figma', 'Material UI'],
    links: 'https://www.warriorswithoutcause.org/',
    img: wwcNgo
  },
  {
    heading: "Sage Threads",
    description: "Business website for a premium thread manufacturer with product showcases and enquiry system. Ranks #1 on Google for 'Sage Threads' through SEO.",
    techStack: ['HTML', 'CSS', 'SEO'],
    links: 'https://sagethreads.vercel.app/',
    img: sageThreds
  },
  {
    heading: "Party Pals",
    description: "Full-featured event planning platform with vendor onboarding, real-time chat via Socket.io, seating, gift registry, and budget tracking.",
    techStack: ['ReactJS', 'MUI', 'ExpressJS', 'MongoDB', 'NodeJS', 'Socket.io'],
    links: "https://party-pals.vercel.app/",
    img: partypals
  },
  {
    heading: "Consultation & Appointment Booking",
    description: "Next.js healthcare platform with online booking and payments — SEO-focused approach drove a 55% increase in appointment bookings.",
    techStack: ['NextJS', 'ExpressJS', 'MongoDB', 'NodeJS'],
    links: "https://dr-sandy.vercel.app/",
    img: chachiCover
  },
  {
    heading: "RoboChat",
    description: "React chatbot with multi-session management and a persistent sidebar UI, powered by the OpenAI API.",
    techStack: ['ReactJS', 'OpenAI API'],
    links: "https://chat-app-pr1yam9.vercel.app/",
    img: robochartCover
  },
  {
    heading: "Imagine-AI",
    description: "React web app for AI image generation from user prompts, built around the Leap-AI API with a clean, flow-first UI.",
    techStack: ['ReactJS', 'ExpressJS', 'MongoDB', 'NodeJS'],
    links: "https://imagineai-teal.vercel.app/",
    img: imagineAiCover
  },
  {
    heading: "Brand Ambassador's Portfolio",
    description: "Responsive portfolio for a Canadian marketing consultant, handling the full development-to-deployment lifecycle.",
    techStack: ['NextJS', 'ExpressJS', 'MongoDB', 'NodeJS'],
    links: "https://www.jagritimalhotra.com",
    img: jagritiCover
  },
];

const Projects = () => {
  return (
    <Accordion className="ACover" preExpanded={["a"]}>
      {data.map((project, index) => (
        <AccordionItem
          className="Accs"
          key={index}
          uuid={String.fromCharCode(97 + index)}
        >
          <AccordionItemHeading>
            <AccordionItemButton>
              <h2 className="Pheading">{project.heading}</h2>
            </AccordionItemButton>
          </AccordionItemHeading>

          <AccordionItemPanel className="accsp">
            <div className="PInternalCover">

              <div className="PImg">
                <a href={project.links} target="_blank" rel="noreferrer">
                  <img className="PimgInner" src={project.img} alt={project.heading} />
                </a>
              </div>

              <div className="Pdesc">
                <div className="PdescHeader">Description</div>
                <div className="PdescInner">{project.description}</div>
              </div>

              <div className="PTStack">
                <div className="PTfirst">
                  <div className="PdescHeader">Tech Stack</div>
                  <div className="PdescInner">
                    {project.techStack.map((tech, i) => (
                      <span key={i} className="techTag">{tech}</span>
                    ))}
                  </div>
                </div>
                <div className="PTsecond">
                  <div className="PdescHeader">Links</div>
                  <a
                    className="Pview"
                    target="_blank"
                    rel="noreferrer"
                    href={project.links}
                  >
                    View ↗
                  </a>
                </div>
              </div>

            </div>
          </AccordionItemPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
};

export default Projects;